import React, { Component } from 'react';
import { FormFieldFunctions } from '../../interfaces/FormField/FormField';
import Snapshot from '../../interfaces/Snapshot/Snapshot';
import FormFieldChooseGroupProps, { FormFieldChooseGroupOption } from './FormFieldChooseGroup.props';
import FormFieldChooseGroupState from './FormFieldChooseGroup.state';

export default class FormFieldChooseGroup extends Component<FormFieldChooseGroupProps, FormFieldChooseGroupState> implements FormFieldFunctions {
    private chooseGroup: React.RefObject<HTMLDivElement>;

    constructor(props: FormFieldChooseGroupProps) {
        super(props);
        this.state = {
            value: this.props.value || '',
            checked: this.props.options && this.props.options.findIndex(option => option.value === this.props.value) >= 0,
        };

        this.chooseGroup = React.createRef<HTMLDivElement>();
        this.handleChange = this.handleChange.bind(this);
    }

    updateAndNotify = () => {
        this.setState({
            value: this.props.value || '',
            checked: this.props.options && this.props.options.findIndex(option => option.value === this.props.value) >= 0,
        }, () => {
            this.props.onChange && this.props.onChange(this.state.value);
        });
    }

    getSnapshotBeforeUpdate(prevProps: FormFieldChooseGroupProps): Snapshot {
        return { notifyRequired: prevProps.value !== this.props.value };
    }

    componentDidUpdate(prevProps: FormFieldChooseGroupProps, prevState: FormFieldChooseGroupState, snapshot: Snapshot) {
        if (snapshot.notifyRequired) {
            this.updateAndNotify();
        }
    }

    handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            value: e.target.value,
            checked: e.target.checked,
        }, () => {
            if (this.isValid()) {
                // console.log('changes')
                this.toggleValidationError(false);
            } else {
                this.toggleValidationError(true)
            }
            this.props.onChange && this.props.onChange(this.state.value, e);
        });
    }

    isValid() {
        const value = this.getValue() || '';
        if (this.props.required && value.trim() === '') {
            return false;
        }

        if (this.props.mustBeTrue && value.trim() !== 'true') {
            return false;
        }

        return true;
    }

    toggleValidationError(show: boolean) {
        if (show) {
            this.chooseGroup.current?.parentElement?.classList.add('form__field--error');
            this.setState({
                value: 'false'
            })
        } else {
            this.chooseGroup.current?.parentElement?.classList.remove('form__field--error');
        }
    }

    getValue() {
        return this.state.checked ? this.state.value : this.props.shouldReturnFalseThanUndefinedIfNotChecked ? 'false' : undefined;
    }

    render(): React.ReactNode {
        return (
            <div className={"choose-group choose-group--legend-position-inline" + (this.props.alternativeStyle ? ' choose-group--alternative' : '') + (this.props.id ? ` choose-group--${this.props.id}` : '')}
                ref={this.chooseGroup}>
                <fieldset className="choose-group__fieldset">
                    {this.props.label && <legend className="choose-group__legend">{this.props.label}</legend>}
                    <div className="choose-group__option-container" style={this.props.readOnly || (this.props.isLoggedIn
                        && ((this.props.required && this.isValid()) || !this.props.required)) 
                        ? {
                            pointerEvents: "none",
                        } 
                        : undefined
                    }>
                        {
                            this.props.options?.map((option: FormFieldChooseGroupOption, index: number) => {
                                return <div className="choose-group__option" key={this.props.id + index}>
                                    <div className={"checkbox choose-group__checkbox checkbox--" + (this.props.optionStyle || 'radio')}>
                                        <input id={this.props.id + index}
                                            className="checkbox__input"
                                            type={this.props.optionStyle || 'radio'}
                                            name={this.props.id}
                                            defaultValue={option.value}
                                            required={this.props.required}
                                            onChange={this.handleChange}
                                            readOnly={this.props.readOnly || (this.props.isLoggedIn
                                                && ((this.props.required && this.isValid()) || !this.props.required))}
                                            defaultChecked={this.props.defaultChecked ? this.props.defaultChecked : this.props.optionStyle && this.props.optionStyle !== 'radio' ? option.value === this.state.value : undefined}
                                            checked={(this.props.optionStyle || 'radio') === 'radio' ? option.value === this.state.value : undefined} />
                                        <label className="checkbox__label" htmlFor={this.props.id + index}>
                                            <div className="checkbox__shape"></div>
                                        </label>
                                    </div>
                                    {
                                        option.label && <label className="choose-group__input-label"
                                            htmlFor={this.props.id + index}
                                            dangerouslySetInnerHTML={{ __html: option.label }}></label>
                                    }
                                </div>
                            })
                        }
                    </div>
                </fieldset>
            </div>
        );
    }
}
